import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicContentComponent } from '../dynamic-content/dynamic-content.component';

@Component({
  selector: 'app-hub-item-message',
  templateUrl: './hub-item-message.component.html',
  styleUrls: ['./hub-item-message.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DynamicContentComponent]
})
export class HubItemMessageComponent {
  @Input() content: string;
  public showOverlay = false;
}
